import * as moment from 'moment-timezone'
import { transform, snakeCase } from 'lodash'
import firebase from 'firebase/compat/app'
import { CalendarEvent } from '../models'

// function to help transform data received from the API into CalendarEvent model
export const getTransformedCalendarEvents = ({ events }: { events: any[] }) => {
  const dateFields = ['dateAdded','dateUpdated', 'startTime', 'endTime']
  const calendarEvents = events.map(event => {
    const transformedData = transform(event, (result, val, key: string) => {
      if (key === 'appointmentStatus') {
        result['appoinment_status'] = val
      } else if (dateFields.includes(key)) {
        result[snakeCase(key)] = moment(val)
      } else {
        result[snakeCase(key)] = val
      }
    }, {} as any)

    if (transformedData.event_id) { // the record came from calendar_event_attendees collection
      transformedData.id = transformedData.event_id
    }
    transformedData.date_added = firebase.firestore.Timestamp.fromMillis(transformedData.date_added) 
    transformedData.date_updated = firebase.firestore.Timestamp.fromMillis(transformedData.date_updated) 
    transformedData.ref = CalendarEvent.collectionRef().doc(transformedData.id)
    return new CalendarEvent(transformedData)
  })

  return calendarEvents
}
